import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctString, FctValue } from '../../../../Fct/generics';
export var TokenURI = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'tokenURI',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721', isPreview: true, }),
                methodParams: {
                    tokenId: new FctValue({}),
                },
            },
            output: {
                uri: new FctString({ innerIndex: 0 }),
            },
        });
    },
});
